import React, { useState, useEffect, useCallback } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SimpleCaptchaProps {
  onValidChange: (valid: boolean) => void;
}

const SimpleCaptcha = ({ onValidChange }: SimpleCaptchaProps) => {
  const { t } = useTranslation('account');
  const [a, setA] = useState(0);
  const [b, setB] = useState(0);
  const [answer, setAnswer] = useState('');

  const generate = useCallback(() => {
    const newA = Math.floor(Math.random() * 10) + 1;
    const newB = Math.floor(Math.random() * 10) + 1;
    setA(newA);
    setB(newB);
    setAnswer('');
    onValidChange(false);
  }, [onValidChange]);

  useEffect(() => {
    generate();
  }, [generate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setAnswer(val);
    onValidChange(parseInt(val) === a + b);
  };

  return (
    <div className="space-y-2">
      <Label>{t('captcha.label', { a, b })}</Label>
      <div className="flex items-center gap-2">
        <Input
          type="number"
          value={answer}
          onChange={handleChange}
          placeholder={t('captcha.placeholder')}
          className="max-w-[140px]"
          required
        />
        <button
          type="button"
          onClick={generate}
          className="text-muted-foreground hover:text-foreground"
          title={t('captcha.newQuestion')}
        >
          <RefreshCw className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default SimpleCaptcha;
